// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffcommon/v1/eex_model.proto (package bffcommon.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaType } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { EEXHourType, EEXPeriodType } from "../../bfftypes/v1/eex_pb";
import { file_bfftypes_v1_eex } from "../../bfftypes/v1/eex_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffcommon/v1/eex_model.proto.
 */
export const file_bffcommon_v1_eex_model: GenFile = /*@__PURE__*/
  fileDesc("ChxiZmZjb21tb24vdjEvZWV4X21vZGVsLnByb3RvEgxiZmZjb21tb24udjEi4gIKCENvbnRyYWN0EgwKBGNvZGUYASABKAkSEgoKaW5zdHJ1bWVudBgCIAEoCRIoCglhcmVhX3R5cGUYAyABKA4yFS5iZmZ0eXBlcy52MS5BcmVhVHlwZRIvCgtwZXJpb2RfdHlwZRgEIAEoDjIaLmJmZnR5cGVzLnYxLkVFWFBlcmlvZFR5cGUSNQoRZGVsaXZlcnlfc3RhcnRfYXQYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjMKD2RlbGl2ZXJ5X2VuZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASKwoJaG91cl90eXBlGAcgASgOMhguYmZmdHlwZXMudjEuRUVYSG91clR5cGUSHwoXdG91Y2hwb2ludF9kaXNwbGF5X25hbWUYCCABKAkSHwoXaW5zdHJ1bWVudF9kaXNwbGF5X25hbWUYCSABKAlCvgEKEGNvbS5iZmZjb21tb24udjFCDUVleE1vZGVsUHJvdG9QAVpKZ2l0aHViLmNvbS9lbmVjaGFpbi9lcG9zaXRpb24tYXBwL2JhY2tlbmQvZ2VuL3Byb3RvL2JmZmNvbW1vbi92MTtiZmZjb21tb26iAgNCWFiqAgxCZmZjb21tb24uVjHKAgxCZmZjb21tb25cVjHiAhhCZmZjb21tb25cVjFcR1BCTWV0YWRhdGHqAg1CZmZjb21tb246OlYxYgZwcm90bzM", [file_bfftypes_v1_area, file_bfftypes_v1_eex, file_google_protobuf_timestamp]);

/**
 * EEXで管理されているContract (Product + 限月等).
 *
 * @generated from message bffcommon.v1.Contract
 */
export type Contract = Message<"bffcommon.v1.Contract"> & {
  /**
   * EEX上のコード
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * EEX上のinstrumentコード (限月等)
   *
   * @generated from field: string instrument = 2;
   */
  instrument: string;

  /**
   * エリア種別
   *
   * @generated from field: bfftypes.v1.AreaType area_type = 3;
   */
  areaType: AreaType;

  /**
   * 受渡期間種別
   *
   * @generated from field: bfftypes.v1.EEXPeriodType period_type = 4;
   */
  periodType: EEXPeriodType;

  /**
   * 休日等を無視した、商品自体の受給期間の開始日時
   *
   * @generated from field: google.protobuf.Timestamp delivery_start_at = 5;
   */
  deliveryStartAt?: Timestamp;

  /**
   * 休日等を無視した、商品自体の受給期間の終了日時
   *
   * @generated from field: google.protobuf.Timestamp delivery_end_at = 6;
   */
  deliveryEndAt?: Timestamp;

  /**
   * 時間帯種別
   *
   * @generated from field: bfftypes.v1.EEXHourType hour_type = 7;
   */
  hourType: EEXHourType;

  /**
   * タッチポイントでの表示名
   *
   * @generated from field: string touchpoint_display_name = 8;
   */
  touchpointDisplayName: string;

  /**
   * enecプロダクト(eSL, eClear等)でのinstrument(限月)の表示名
   *
   * @generated from field: string instrument_display_name = 9;
   */
  instrumentDisplayName: string;
};

/**
 * Describes the message bffcommon.v1.Contract.
 * Use `create(ContractSchema)` to create a new message.
 */
export const ContractSchema: GenMessage<Contract> = /*@__PURE__*/
  messageDesc(file_bffcommon_v1_eex_model, 0);

